import * as React from "react"
import type { SVGProps } from "react"
const SvgRedo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16 19q.42 0 .71-.29.3-.29.29-.71 0-.42-.29-.71A1 1 0 0 0 16 17H9.9a4 4 0 0 1-2.74-1A3.2 3.2 0 0 1 6 13.5Q6 12 7.16 11q1.17-1 2.74-1h6.3l-1.9 1.9a1 1 0 0 0-.28.7q0 .43.28.7.27.27.7.27t.7-.27l3.6-3.6q.15-.14.21-.32a1 1 0 0 0 0-.75 1 1 0 0 0-.21-.33l-3.6-3.6a1 1 0 0 0-.7-.27q-.43 0-.7.27a1 1 0 0 0-.28.7q0 .42.28.7L16.2 8H9.9Q7.47 8 5.74 9.58A5 5 0 0 0 4 13.5q0 2.36 1.74 3.93A6 6 0 0 0 9.9 19z" />
  </svg>
)
export default SvgRedo
